/*
 * @Author: Merlin
 * @Date: 2025-04-11 10:16:19
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-11 17:29:16
 * @Description: 
 */
import {
    type NotificationsParams,
    type NotificationsPage,
} from './dto/index';


export const useNotificationSocket = () => {
    const rootPath = 'notifications';
    
    // 监听通知列表推送
    const ON_NOTIFICATIONS_LIST = (
        callback: any,
    ) => {
        socket.on(`${rootPath}.list`, callback);
    }
    // 关闭推送列表
    const EMIT_NOTIFICATIONS_MARK = (
        data: NotificationsParams,
        callback: any
    ) => {
        socket.emit(`${rootPath}.mark`, data, callback);
    }

    // ↓ 二期新增，从接口文档复制到此，但暂时没启用 
    /**
     * 查询消息列表 
     * @param data 
     * @returns 
     */
    const EMIT_NOTIFICATIONS_PAGE = async (
        data: NotificationsPage,
    ) => {
        // 422["notifications.getN",{"type":"system","page":1}]	
        const res = await asyncEmit(
            `${rootPath}.getN`,
            data,
        );
        return res;
    }

    /**
     * 查询未读消息数量 
     * @param data 
     * @returns 
     */
    const EMIT_NOTIFICATIONS_UNREAD_COUNT = async (
        // 无
    ) => {
        // 425["notifications.unreadCount",{}]	
        // 435[{"system":2,"personal":1}]	
        const res = await asyncEmit<{
            system: number;
            personal: number;
        }>(
            `${rootPath}.unreadCount`,
            {},
        );
        return res;
    }

    /**
     * 标记某消息为已读
     * @param data 
     * @returns 
     */
    const EMIT_NOTIFICATIONS_SET_READ = async (
        // 无
    ) => {
        // 427["notifications.read",{"notificationId":"22"}]	
        // 4313[{}]	
        const res = await asyncEmit(
            `${rootPath}.read`,
            {},
        );
        return res;
    }

    return {
        ON_NOTIFICATIONS_LIST,
        EMIT_NOTIFICATIONS_MARK,
        // 以下用途不明 
        // EMIT_NOTIFICATIONS_PAGE,
        // EMIT_NOTIFICATIONS_UNREAD_COUNT,
        // EMIT_NOTIFICATIONS_SET_READ,
    };
};

